import { Box, Button, Drawer, Stack, TextField } from "@mui/material";
import FilterIcon from "src/assets/svg-icons/filter.svg";
import { useTranslation } from "react-i18next";
import { useState } from "react";

interface IProps {
  open: boolean;
  handleClose: any;
  companyId: string;
  setCompanyId: Function;
  email: string;
  setEmail: Function;
  phone: string;
  setPhone: Function;
}

const FilterDrawer = (props: IProps) => {
  const { t } = useTranslation("customers");
  const { t: generalT } = useTranslation("general");
  const {
    open,
    handleClose,
    companyId,
    setCompanyId,
    email,
    setEmail,
    phone,
    setPhone,
  } = props;
  const [tempCompanyId, setTempCompanyId] = useState(companyId);
  const [tempEmail, setTempEmail] = useState(email);
  const [tempPhone, setTempPhone] = useState(phone);

  const handleApply = () => {
    handleClose();
    setCompanyId(tempCompanyId);
    setEmail(tempEmail);
    setPhone(tempPhone);
  };

  const handleClearFilters = () => {
    handleClose();
    setCompanyId("");
    setEmail("");
    setPhone("");

    setTempCompanyId("");
    setTempEmail("");
    setTempPhone("");
  };

  return (
    <Drawer anchor={"right"} open={open} onClose={handleClose}>
      <Stack
        maxWidth={{ xs: "100%", sm: "376px" }}
        minWidth={{ xs: "100%", sm: "376px" }}
        borderRight={"1px solid #D0D5DD"}
        height={"100%"}
        maxHeight={"100vh"}
        top={"0"}
      >
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
        >
          <Button
            color="tertiary"
            variant="text"
            size="small"
            endIcon={<img src={FilterIcon} height={"16px"} alt="" />}
          >
            {t("filter")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClose}
          >
            {t("hide")}
          </Button>
        </Box>
        <Stack spacing={"20px"} p={"40px 27px"}>
          {/* name */}
          <TextField
            label={t("companyID")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempCompanyId}
            onChange={(e) => setTempCompanyId(e.target.value)}
          />
          {/* sku */}
          <TextField
            label={t("email")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempEmail}
            onChange={(e) => setTempEmail(e.target.value)}
          />
          {/*  type */}
          <TextField
            label={t("phone")}
            variant="outlined"
            size="small"
            fullWidth
            value={tempPhone}
            onChange={(e) => setTempPhone(e.target.value)}
          />
          {/* divider */}
          <Box width={"100%"} height={"1px"} bgcolor={"#CBD5E1"} />
        </Stack>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          p={"20px 27px"}
          bgcolor={"#fff"}
          boxShadow="0px 0px 40px 0px rgba(11, 24, 42, 0.07)"
          alignItems={"flex-end"}
          mt="auto"
        >
          <Button variant="contained" size="small" onClick={handleApply}>
            {generalT("apply")}
          </Button>
          <Button
            variant="outlined"
            color="tertiary"
            size="small"
            onClick={handleClearFilters}
          >
            {generalT("clear")}
          </Button>
        </Box>
      </Stack>
    </Drawer>
  );
};
export default FilterDrawer;
